<template>
  <a-layout class="app-layout">
    <!-- 顶部 Header -->
    <AppHeader />

    <a-layout class="layout-content">
      <!-- 左侧菜单 -->
      <AppSidebar />

      <!-- 主内容区 -->
      <a-layout-content class="main-content">
        <div class="content-wrapper">
          <router-view v-slot="{ Component }">
            <keep-alive :include="['PageView']">
              <component :is="Component" />
            </keep-alive>
          </router-view>
        </div>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>

<script>
import AppHeader from '../../components/filters/AppHeader.vue'
import AppSidebar from '../../components/filters/AppSidebar.vue'

export default {
  name: 'DeviceLayout',
  components: {
    AppHeader,
    AppSidebar
  },
}
</script>

<style scoped>
.app-layout {
  min-height: 100vh;
  background: #f0f2f5;
}

.layout-content {
  margin-top: 64px;
  height: calc(100vh - 64px);
  display: flex;
  flex-direction: row;
}

.main-content {
  margin-left: 208px;
  padding: 24px;
  background: #f0f2f5;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* 1366*768 和 pad 响应式优化 */
@media (max-width: 1366px) {
  .main-content {
    padding: 16px;
  }
}

/* Pad 设备优化 */
@media (max-width: 1024px) {
  .main-content {
    margin-left: 0;
    padding: 12px;
  }
}

/* 移动端优化 */
@media (max-width: 767px) {
  .main-content {
    margin-left: 0;
    padding: 0;
    height: calc(100vh - 64px);
    margin-top: 0;
  }
  
  .layout-content {
    margin-top: 64px;
    height: calc(100vh - 64px);
  }
  
  .content-wrapper {
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    margin: 0;
    padding: 0;
  }
}

.content-wrapper {
  background: transparent;
  flex: 1;
  overflow-y: auto;
  /* 移除 overflow-x: hidden，允许表格横向滚动 */
  overflow-x: visible;
  min-height: 0;
}

@media (max-width: 767px) {
  .content-wrapper {
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
}
</style>
